import React from 'react';

const InputComponent = ({
  onChange, value, name, maxLength, title = '', placeHolder, type = 'text', disabled = false,
}) => (
  <div className="form-group">
    <p className="margin-bottom-2">{title || ''}</p>
    <input
      type={type}
      className="form-control"
      placeholder={placeHolder}
      onChange={onChange}
      value={value}
      name={name}
      maxLength={maxLength}
      disabled={disabled}
    />
  </div>
);

export default InputComponent;
